import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/site/Reveal";

export const CTABand = () => (
  <section data-testid="cta-band" className="relative overflow-hidden bg-brand">
    <div className="absolute inset-0 opacity-20 grain" />
    <div className="max-w-container mx-auto px-6 md:px-12 py-20 md:py-28 relative">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-8">
          <Overline className="text-white/70">Ready when you are</Overline>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl tracking-tighter text-white leading-[1.05]">
            Let's build a safer, cleaner,<br className="hidden md:block" /> better-run estate.
          </h2>
          <p className="mt-6 text-white/80 text-lg max-w-xl">
            Tell us about your sites and we'll design a single, accountable facilities contract around them.
          </p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <Reveal>
            <Link
              to="/quote"
              data-testid="ctaband-quote-button"
              className="inline-flex items-center gap-3 bg-ink text-white font-semibold px-8 py-5 hover:bg-black transition-colors duration-300 group"
            >
              Request a Quote
              <ArrowUpRight size={20} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
